import { ActivatedRoute, Router } from '@angular/router';
import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { UserService } from './../../services/user.service';
import { CompaniesService } from './../../services/companies.service';
import { environment } from '../../../environments/environment';
import COUNTRY_CODE from './../../constant/country';
import { PaymentType } from './../../constant/PaymentType';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';
import STATES from '../../constant/states';
import { CompanyCodeValidator } from '../../utils/validate/CompanyCodeValidator';
import _ from 'lodash';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CurrencyPipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { ExtendedModule } from '@angular/flex-layout';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatError } from '@angular/material/input';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  imports: [
    NgClass,
    MatToolbar,
    MatToolbarRow,
    ExtendedModule,
    FaIconComponent,
    MatIcon,
    MatIconButton,
    ReactiveFormsModule,
    MatError,
    NgIf,
    NgForOf,
    CurrencyPipe,
  ],
})
export class SignupComponent implements OnInit {
  faPhoneSquareAlt = faPhoneSquare;
  signUpForm: FormGroup;
  submitted = false;
  submittedOne = false;
  submittedTwo = false;
  submittedThree = false;
  submittedFor = false;
  isShowStepOne = true;
  isShowStepTwo = false;
  isShowStepCoupon = false;
  isShowStepThree = false;
  isShowStepFour = false;
  isDisabledOne = false;
  isValidatingEmail = signal(false);
  isDisabledTwo = false;
  isDisabledThree = false;
  isActiveTwo = false;
  isActiveCoupon = false;
  isActiveThree = false;
  isActiveFour = false;
  isCheckCompanyCode = false;
  isShowStepThree1 = false;
  isShowStepThree2 = false;
  isCompanyCodeExist = false;
  isUserEmailExist = false;
  email = '';
  srcLogo = '../../../assets/image/new-logo-long_IDS.png';
  stringError = _.escape('! @ # $ % ^ & * ( ) _ + = | / ? ; : . } { - [ ]');
  product = signal<any>(null);
  productId = 0;
  checkoutId = '';
  isRedirect = false;
  paymentSuccess = false;
  isLoading = signal(false);
  states = STATES;
  allCountry = COUNTRY_CODE;

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private companiesService: CompaniesService,
    private _route: Router,
    private snackBar: MatSnackBar,
    readonly companyCodeValidator: CompanyCodeValidator,
    private ref: ChangeDetectorRef
  ) {
    if (this.activatedRoute.snapshot.params['id']) {
      this.onGetProduct();
    } else {
      return;
    }
  }

  ngOnInit() {
    this.processPaymentIfNeeded();
    this.valueChangeEmail();
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    // visible height + pixel scrolled >= total height
    if (
      event.target.offsetHeight + event.target.scrollTop >=
      event.target.scrollHeight
    ) {
      this.isDisabledThree = true;
    } else {
      this.isDisabledThree = false;
    }
  }

  private onGetProduct() {
    this.isLoading.set(true);
    this.productId = parseInt(this.activatedRoute.snapshot.params['id'], 10);
    this.companiesService.getPackageById(this.productId).subscribe(
      (rs: any) => {
        this.isLoading.set(false);
        if (rs) {
          const productData = {
            Id: rs.Package_Id,
            Name_Plan: rs.Package_Name,
            Price: rs.Price,
            Price_Sale: rs.Price_Sale,
            Number_User: rs.Max_User,
            Benefit: rs.Benefit.split(','),
            Plan_Id: rs.Plan_Id,
            IsDeleted: rs.IsDeleted,
          };
          this.product.set(productData);
          sessionStorage.setItem('product', JSON.stringify(productData));
        }
      },
      err => {
        console.log(err);
        this.isLoading.set(false);
      }
    );
  }

  onAgree() {
    if (this.isRedirect) {
      this.isShowStepThree1 = false;
      this.isShowStepThree2 = true;
    } else {
      this.isShowStepThree1 = false;
      this.isShowStepThree2 = true;
    }
  }

  private processPaymentIfNeeded() {
    if (this.activatedRoute.snapshot.queryParams['success']) {
      // redirect from stripe
      this.isRedirect = true;
      this.paymentSuccess =
        this.activatedRoute.snapshot.queryParams['success'] === 'true'
          ? true
          : false;
      this.refillFormByQueryParams();
      this.removeQueryParams();
      if (this.paymentSuccess === true) {
        this.onNextStep(3);
        if (this.activatedRoute.snapshot.queryParams['session_id']) {
          // payment success
          this.checkoutId =
            this.activatedRoute.snapshot.queryParams['session_id'];
          this.createCompany(this.checkoutId);
        } else {
          // wrong query params => ?????
        }
      } else {
        // payment fail
        this.setPaymentSuccess(false);
      }
    } else {
      // create new company
      this.isRedirect = false;
      this.newForm();
    }
  }

  private refillFormByQueryParams() {
    this.signUpForm = this.formBuilder.group({
      email: [
        this.activatedRoute.snapshot.queryParams['email'],
        [Validators.required, Validators.email],
      ],
      firstName: [
        this.activatedRoute.snapshot.queryParams['firstName'],
        Validators.required,
      ],
      lastName: [
        this.activatedRoute.snapshot.queryParams['lastName'],
        Validators.required,
      ],
      phoneNumber: [
        this.activatedRoute.snapshot.queryParams['phoneNumber'],
        Validators.required,
      ],
      country: [
        this.activatedRoute.snapshot.queryParams['country'],
        Validators.required,
      ],
      companyName: [
        this.activatedRoute.snapshot.queryParams['companyName'],
        Validators.required,
      ],
      companyCode: [this.activatedRoute.snapshot.queryParams['companyCode']],
      billingAddress1: [''],
      billingAddress2: [''],
      coupon: [this.activatedRoute.snapshot.queryParams['companyCoupon']],
      city: [''],
      state: [''],
      zip: [''],
      aboutus: [this.activatedRoute.snapshot.queryParams['companyAboutus']],
    });
  }

  private newForm() {
    this.signUpForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phoneNumber: ['', Validators.required],
      country: ['', Validators.required],
      companyName: ['', [Validators.required]],
      companyCode: [
        '',
        {
          validators: [
            Validators.required,
            Validators.pattern('^[a-zA-Z0-9._-]+$'),
          ],
          asyncValidators: [this.companyCodeValidator],
        },
      ],
      billingAddress1: [''],
      billingAddress2: [''],
      coupon: [''],
      city: [''],
      state: [''],
      zip: [''],
      aboutus: ['', [Validators.maxLength(30)]],
    });
  }

  private setPaymentSuccess(success: boolean) {
    this.isShowStepOne = false;
    this.isActiveTwo = true;
    this.isShowStepTwo = false;
    this.isActiveThree = true;
    this.isActiveCoupon = true;
    this.isShowStepThree1 = false;
    if (success === true) {
      this.isShowStepThree = false;
      this.isShowStepThree2 = false;
      this.isActiveFour = true;
      this.isShowStepFour = true;
    } else {
      // this.isShowStepThree = true;
      // this.isShowStepThree2 = true;
      this.isShowStepTwo = true;
      this.isActiveFour = false;
      this.isShowStepFour = false;
      this.isDisabledTwo = true;
      // this.signUpForm.markAsTouched();
    }
    this.ref.detectChanges();
  }

  private removeQueryParams() {
    this._route.navigate([], {
      queryParams: {
        email: null,
        firstName: null,
        lastName: null,
        phoneNumber: null,
        country: null,
        companyName: null,
        companyCode: null,
        session_id: null,
        success: null,
      },
      queryParamsHandling: 'merge',
    });
  }

  valueChangeEmail() {
    this.signUpForm.get('email').valueChanges.subscribe(value => {
      this.isUserEmailExist = false;
      this.isDisabledOne = true;
    });
  }

  get f() {
    return this.signUpForm.controls;
  }

  onToggleStep(idx: number) {
    if (idx === 1) {
      if (!this.isShowStepOne) {
        this.onOpenStep(idx);
      } else {
        this.onCloseStep(idx);
      }
    } else if (idx === 2) {
      if (!this.isShowStepTwo) {
        this.onOpenStep(idx);
      } else {
        this.onCloseStep(idx);
      }
    } else if (idx === 23) {
      if (!this.isShowStepCoupon) {
        this.onOpenStep(idx);
      } else {
        this.onCloseStep(idx);
      }
    } else if (idx === 3) {
      if (!this.isShowStepThree) {
        this.onOpenStep(idx);
      } else {
        this.onCloseStep(idx);
      }
    } else if (idx === 4) {
      if (!this.isShowStepFour) {
        this.onOpenStep(idx);
      } else {
        this.onCloseStep(idx);
      }
    }
  }

  onOpenStep(idx: number) {
    if (idx === 1) {
      this.isShowStepOne = true;
    } else if (idx === 2) {
      this.isShowStepTwo = true;
    } else if (idx === 23) {
      this.isShowStepCoupon = true;
    } else if (idx === 3) {
      this.isShowStepThree = true;
      this.isShowStepThree1 = true;
      this.isShowStepThree2 = false;
    } else if (idx === 4) {
      this.isShowStepFour = true;
    }
  }

  onCloseStep(idx: number) {
    if (idx === 1) {
      this.isShowStepOne = false;
    } else if (idx === 2) {
      this.isShowStepTwo = false;
    } else if (idx === 23) {
      this.isShowStepCoupon = false;
    } else if (idx === 3) {
      this.isShowStepThree = false;
    } else if (idx === 4) {
      this.isShowStepFour = false;
    }
  }

  onCheckvalidateStep1() {
    if (this.signUpForm.get('email').invalid) {
      this.isDisabledOne = false;
      return;
    }
    this.submittedOne = true;
    this.isValidatingEmail.set(true);
    const email = this.signUpForm.get('email').value;
    const httpParams = new HttpParams()
      .set('update', '')
      .set('company', '')
      .set('current', email)
      .set('type', 'email');
    this.userService.confirmUserInformation(httpParams).subscribe(
      (rs: boolean) => {
        this.isValidatingEmail.set(false);
        this.isUserEmailExist = rs;
        if (!this.isUserEmailExist) {
          this.isShowStepOne = false;
          this.onOpenStep(2);
          this.isActiveTwo = true;
        } else {
          this.isDisabledOne = false;
        }
      },
      err => {
        this.isValidatingEmail.set(false);
        console.log(err);
      }
    );
  }

  onCheckvalidateStep2() {
    this.submittedTwo = true;
    if (
      this.signUpForm.get('firstName').invalid ||
      this.signUpForm.get('lastName').invalid ||
      this.signUpForm.get('phoneNumber').invalid ||
      this.signUpForm.get('country').invalid ||
      this.signUpForm.get('companyName').invalid
    ) {
      return false;
    }
    return true;
  }

  onNextStep(idx: number) {
    this.isShowStepOne = false;
    this.isShowStepTwo = false;
    this.isShowStepCoupon = false;
    this.isShowStepThree = false;
    this.isShowStepFour = false;
    // if (idx == 1 && this.onCheckvalidateStep1()) {
    // 	this.onOpenStep(idx+1);
    // 	this.isActiveTwo = true;
    // } else
    if (idx === 2 && this.onCheckvalidateStep2()) {
      this.onOpenStep(23);
      this.isActiveCoupon = true;
    } else if (idx === 23) {
      this.onOpenStep(3);
      this.isActiveThree = true;
    } else if (idx === 3) {
      this.onOpenStep(idx + 1);
      this.isActiveFour = true;
    }
    return;
  }

  onChangeInputTow(event: any) {
    if (
      this.signUpForm.get('firstName').invalid ||
      this.signUpForm.get('lastName').invalid ||
      this.signUpForm.get('phoneNumber').invalid ||
      this.signUpForm.get('country').invalid ||
      this.signUpForm.get('companyName').invalid
    ) {
      this.isDisabledTwo = false;
    } else {
      this.isDisabledTwo = true;
    }
  }

  onChangeCompanyName() {
    const companyName = this.signUpForm.get('companyName').value;
    this.companiesService.generateCompanyCode(companyName).subscribe(rs => {
      this.signUpForm.get('companyCode').setValue(rs);
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.signUpForm.invalid) {
      return;
    }
  }

  onBackHome() {
    window.location.href = environment.home;
  }

  private createCompany(checkoutId: string) {
    this.isLoading.set(true);
    const productData = JSON.parse(sessionStorage.getItem('product'));
    this.product.set(productData);
    const pack = {
      Package_Id: this.productId,
      Plan_Id: productData.Plan_Id,
      Price: productData.Price,
      Price_Sale: productData.Price_Sale,
    };
    const pay = {
      Package_Id: this.productId,
      Amount: productData.Price_Sale,
      Transaction_Id: checkoutId,
      Type: PaymentType.Stripe_Checkout,
      Email: this.f['email'].value,
    };
    const model = {
      Primary_Contact_Email: this.f['email'].value,
      Primary_Contact_Name:
        this.f['firstName'].value + ' ' + this.f['lastName'].value,
      Primary_Contact_Phone_Number: this.f['phoneNumber'].value,
      Address: this.f['country'].value,
      Company_Name: this.f['companyName'].value,
      Company_Code: this.f['companyCode'].value,
      Company_Coupon: this.f['coupon'].value,
      Company_Aboutus: this.f['aboutus'].value,
      Package_Id: this.productId,
      Checkout_Id: checkoutId,
      First_Name: this.f['firstName'].value,
      Last_Name: this.f['lastName'].value,
      Package: pack,
      Current_Payment: pay,
    };
    this.companiesService.registerCompany(model).subscribe(
      rs => {
        if (rs) {
          this.setPaymentSuccess(true);
        }
        this.isLoading.set(false);
      },
      err => {
        console.log(err);
        this.isLoading.set(false);
      }
    );
  }

  createPaymentSession() {
    if (this.product() == null) {
      return;
    }
    if (this.signUpForm.invalid) {
      return;
    }
    let queryParams = `email=${this.f['email'].value}`;
    queryParams += `&firstName=${this.f['firstName'].value}`;
    queryParams += `&lastName=${this.f['lastName'].value}`;
    queryParams += `&phoneNumber=${this.f['phoneNumber'].value}`;
    queryParams += `&country=${this.f['country'].value}`;
    queryParams += `&companyName=${this.f['companyName'].value}`;
    queryParams += `&companyCode=${this.f['companyCode'].value}`;
    queryParams += `&companyCoupon=${this.f['coupon'].value}`;
    queryParams += `&companyAboutus=${this.f['aboutus'].value}`;
    const successUrl = `${window.location.href}?${queryParams}&success=${true}&session_id={CHECKOUT_SESSION_ID}`;
    const cancelUrl = `${window.location.href}?${queryParams}&success=${false}`;
    const company = {
      email: this.f['email'].value,
      firstName: this.f['firstName'].value,
      lastName: this.f['lastName'].value,
      phoneNumber: this.f['phoneNumber'].value,
      country: this.f['country'].value,
      companyName: this.f['companyName'].value,
      companyCode: this.f['companyCode'].value,
      coupon: this.f['coupon'].value,
      productId: this.product().Plan_Id,
      successUrl: successUrl,
      cancelUrl: cancelUrl,
      zip: this.f['zip'].value,
      aboutus: this.f['aboutus'].value,
      billingAddress1: this.f['billingAddress1'].value,
      billingAddress2: this.f['billingAddress2'].value,
      state: this.f['state'].value,
      city: this.f['city'].value,
    };

    this.companiesService.createPaymentSession(company).subscribe(
      (data: any) => {
        const stripe: stripe.Stripe = Stripe(environment.stripe_api_key);
        stripe.redirectToCheckout({ sessionId: data.id });
      },
      err => {
        this.snackBar.open(err.error.Message, null, { duration: 3000 });
      }
    );
  }

  onPayment() {
    if (this.product() == null) {
      return;
    }
    if (this.signUpForm.invalid) {
      return;
    }
    const stripe: stripe.Stripe = Stripe(environment.stripe_api_key);
    let queryParams = `email=${this.f['email'].value}`;
    queryParams += `&firstName=${this.f['firstName'].value}`;
    queryParams += `&lastName=${this.f['lastName'].value}`;
    queryParams += `&phoneNumber=${this.f['phoneNumber'].value}`;
    queryParams += `&country=${this.f['country'].value}`;
    queryParams += `&companyName=${this.f['companyName'].value}`;
    queryParams += `&companyCode=${this.f['companyCode'].value}`;
    queryParams += `&companyCoupon=${this.f['coupon'].value}`;
    queryParams += `&companyAboutus=${this.f['aboutus'].value}`;

    stripe.redirectToCheckout({
      items: [
        {
          plan: this.product().Plan_Id,
          // plan: 'plan_GtZTJxalwJ4S3K',
          quantity: 1,
        },
      ],
      successUrl: `${window.location.href}?${queryParams}&success=${true}&session_id={CHECKOUT_SESSION_ID}`,
      cancelUrl: `${window.location.href}?${queryParams}&success=${false}`,
    });
  }

  openNav() {
    document.getElementById('wrapperOver').style.display = 'block';
    document.body.style.position = 'relative';
    document.body.style.left = '-300px';
    document.getElementById('mySidenav').style.width = '300px';
    document.getElementById('main').style.marginRight = '300px';
    document.body.style.backgroundColor = 'rgba(255,255,255,.95)';
    document.body.style.boxShadow =
      'rgba(0, 0, 0, 0.15) -1px 0px 20px 4px inset';
  }

  closeNav() {
    document.getElementById('wrapperOver').style.display = 'none';
    document.body.style.position = 'relative';
    document.body.style.left = '0px';
    document.getElementById('mySidenav').style.width = '0';
    document.getElementById('main').style.marginRight = '0';
    document.body.style.backgroundColor = '#fff';
    document.body.style.boxShadow = 'none';
  }
}
